<div id="message-container">
  <div id="message">
    Portal is in maintenance mode and will be available soon
  </div>
</div>
